import React from "react"
import { useBackfillReportableFieldContext } from "contexts/BackfillReportableFieldContext"
import FieldLabel from "shared/FieldLabel"
import { FormsyHiddenInput } from "shared/inputs"
import { Select } from "shared/selects"

const categoryOptions = (categories) => categories.map((category) => (
  {
    label: category.name,
    value: category.id,
  }
))

const BackfillReportableFieldFormCategory = () => {
  const { categories, selectCategory, selectedCategoryId } = useBackfillReportableFieldContext()

  const options = categoryOptions(categories)

  return (
    <FieldLabel text="Solution">
      <Select
        backspaceDelete={false}
        onChange={selectCategory}
        options={options}
        value={selectedCategoryId}
      />
      <FormsyHiddenInput
        name="categoryId"
        required
        value={selectedCategoryId}
      />
    </FieldLabel>
  )
}

export default BackfillReportableFieldFormCategory
